import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../../store";
import {ActivatedRoute} from "@angular/router";
import {loadPayengine} from "payengine";
import {first, switchMap, takeUntil} from "rxjs/operators";
import {combineLatest, Subject} from "rxjs";

@Component({
    selector: 'db-single-page-payout',
    templateUrl: './single-page-payout.component.html',
    styleUrls: ['./single-page-payout.component.scss'],
    standalone: false
})
export class SinglePagePayoutComponent implements OnInit, AfterViewInit {
  public websiteId: number;

  public payoutsAmountCalculated: boolean;
  public payoutsAmount: any;
  activeMerchant: any;
  existingMerchant: any;
  paymentMode: string;
  loading: boolean = true;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
      private _route: ActivatedRoute,
      private _store: Store<fromStore.DbStoreState>,
  ) {
  }

  ngOnInit() {
    this.websiteId = +this._route.snapshot.params['id'];
  }

  ngAfterViewInit() {
    this._getDomainsMerchants();
  }

  private _getDomainsMerchants(): void {
    this._store.select(fromStore.getMerchantLoaded(this.websiteId))
        .pipe(
            first((loaded) => !!loaded ),
            switchMap(() => combineLatest(
                this._store.select(fromStore.getDomainsMerchants(this.websiteId)),
                this._store.select(fromStore.getEcommercePaymentMode),
                this._store.select(fromStore.getExistingMerchantHash(this.websiteId)),
                this._store.select(fromStore.getExistingMerchantPayoutsAmount(this.websiteId))
            )),
            takeUntil(this._destroyStream$)
        )
        .subscribe(([allMerchants, paymentMode, merchantHash, payoutsAmount]) => {
          if (allMerchants && paymentMode) {
            this.paymentMode = paymentMode;
            this.activeMerchant = allMerchants.find(merchant => merchant?.env === paymentMode);
            this.payoutsAmount = payoutsAmount;
            if (!payoutsAmount && this.activeMerchant?.merchant_id && paymentMode && !this.payoutsAmountCalculated) {
              this.payoutsAmountCalculated = true;
              this._store.dispatch(new fromStore.LoadEcommerceMerchantPayoutsAmount({websiteId: this.websiteId, merchantId: this.activeMerchant?.merchant_id, env: paymentMode}));
            }
          }
          this.existingMerchant = merchantHash;
          if (this.activeMerchant?.merchant_id && !!this.existingMerchant?.merchantHash && this.existingMerchant?.publicKey) {
            this._loadPayEngine(this.activeMerchant?.merchant_id, this.existingMerchant?.merchantHash, this.existingMerchant?.publicKey);
          }
        });
  }

  private _loadPayEngine(merchantId, merchantHash, publicKey): void {
    const payEngine = document.getElementById('pf-single-payouts');
    if (payEngine) {
      payEngine.setAttribute('merchant-id', merchantId);
      payEngine.setAttribute('hash', merchantHash);
      payEngine.setAttribute('view-type', 'funding');
      setTimeout(() => {
        loadPayengine({
          publicKey: publicKey,
        });
        this.loading = false;
      }, 5000);

    }
  }

}
